export default __webpack_public_path__ + "static/media/cel.409f1195.png";